/*  ========================================================================
    # Scripts - What you awaits
    ========================================================================  */

const WhatYouAwaits = {
  config: {
    bigImage: document.querySelector('.s-what-you-awaits__image-big'),
    smallImage: document.querySelector('.s-what-you-awaits__image-small'),
    lightbox: document.querySelector('.s-what-you-awaits__lightbox'),
    lightboxClose: document.querySelector('.s-what-you-awaits__lightbox-close'),
    iFrame: document.querySelector('.s-what-you-awaits__iframe')
  },

  initWhatYouAwaits() {
    this.config.bigImage.addEventListener('click', () => {
      this.openLightbox();
    });

    this.config.smallImage.addEventListener('click', () => {
      this.openLightbox();
    });

    this.config.lightbox.addEventListener('click', () => {
      this.closeLightbox();
    });

    this.config.lightboxClose.addEventListener('click', () => {
      this.closeLightbox();
    });
  },

  openLightbox() {
    this.config.lightbox.classList.add('s-what-you-awaits__lightbox--show');
  },

  closeLightbox() {
    const memory = this.config.iFrame.src;
    this.config.iFrame.src = '';
    this.config.iFrame.src = memory;
    this.config.lightbox.classList.remove('s-what-you-awaits__lightbox--show');
  },

  resizeIFrameToFitContent(iFrame) {
    iFrame.width = iFrame.contentWindow.document.body.scrollWidth;
    iFrame.height = iFrame.contentWindow.document.body.scrollHeight;
  },

  init() {
    this.initWhatYouAwaits();

    window.addEventListener('resize', () => {
      const iFrame = document.querySelector('.s-what-you-awaits__iframe');
      this.resizeIFrameToFitContent(iFrame);
    });
  }
};

export default WhatYouAwaits;
